import { render, staticRenderFns } from "./AxGroupListPanel.vue?vue&type=template&id=3627ba06&scoped=true"
import script from "./AxGroupListPanel.vue?vue&type=script&lang=ts"
export * from "./AxGroupListPanel.vue?vue&type=script&lang=ts"
import style0 from "./AxGroupListPanel.vue?vue&type=style&index=0&id=3627ba06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627ba06",
  null
  
)

export default component.exports